import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';

import { AlarmMonitoring } from 'ops/common/models/alarm-monitoring';
import { lastValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class OpsAlarmApiService {
    private domain: string;
    private headers: any = new HttpHeaders({
        'Content-Type': 'application/json',
    });

    constructor(private http: HttpClient) {
        this.domain = EndPointApi.iApiDomain();
    }

    stopBuzzer(): Promise<any> {
        return lastValueFrom(
            this.http.post(
                `${this.domain}/api/ops/alarms/buzzer`,
                {},
                {
                    headers: this.headers,
                },
            ),
        );
    }

    alarmAcked(alarmData: AlarmMonitoring): Promise<any> {
        return lastValueFrom(
            this.http.post(
                `${this.domain}/api/ops/alarms/ackAlarm`,
                { alarms: [alarmData] },
                {
                    headers: this.headers,
                },
            ),
        );
    }

    allAlarmAcked(alarmsAcked: AlarmMonitoring[]): Promise<any> {
        return lastValueFrom(
            this.http.post(
                `${this.domain}/api/ops/alarms/ackAlarm`,
                { alarms: alarmsAcked },
                {
                    headers: this.headers,
                },
            ),
        );
    }
}
